import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MatAllotService {
  // private apiUrl = "http://localhost:3003/api";
   apiUrl = "https://lexipackghana.com:3003/api";

  constructor(private http: HttpClient) { }

  
  
createMatAllot(matAllotData: any) {
  return this.http.post(this.apiUrl+'/', matAllotData);
}


  // Retrieve all MatMix entries
  getAllMatAllot(){
    return this.http.get(this.apiUrl+'/');
  }

  // Retrieve a MatMix entry by its ID
  getMatAllotById(matAllotId: string) {

    return this.http.get(this.apiUrl+'/'+matAllotId);

  }
  updateMatAllot(matAllotId: string,data:String) {

    return this.http.put(this.apiUrl+'/'+matAllotId,data);

  }
   // Example method to fetch MatAllot data by orderId
   getMatAllotByOrderId(orderId: string) {
    const url = `${this.apiUrl}/matAllot/byOrderId/${orderId}`; // Adjust endpoint URL
    return this.http.get<any[]>(url);
  }
  deleteMatAllot(matAllotId: string) {
    return this.http.delete(this.apiUrl+'/'+matAllotId);
  }

  //many 
  deleteAll(ids: string[]) {
    return this.http.delete<any>(this.apiUrl + '/deleteAll', { body: { ids } });
  }
}